<template>
  <v-card min-height="555">
    <v-stepper v-model="step" style="box-shadow: none;">
      <v-stepper-items>
        <v-stepper-content class="pa-0" step="1">
          <v-layout column class="pa-3">
            <v-flex align-self-center>
              <img :src="require(`@/assets/logomarca.png`)" alt="Logo Apetrus" width="250" class="pa-0 ma-0">
              <h1 style="color: #0B243B; width: 100%; text-align: center;">Redes de Postos</h1>
            </v-flex>
            <h4 class="mt-4" style="text-align: justify;">
              Agora ficou mais fácil gerenciar seus postos! Com o <b>Apetrus Redes de postos</b> você pode tratar seus
              postos como se fosse um,
              negociando com <b>empresas</b> de todo país.
            </h4>
            <h4 class="mt-4" style="width: 100%; text-align: center;">Cadastre agora sua rede!</h4>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="2">
          <v-layout column class="pa-4">
            <h2 style="width: 100%; text-align: center;" class="mb-2">Cadastre sua Rede</h2>
            <v-flex align-self-center>
              <img v-if="imagem && mostrar" :src="imagem" alt="Logo da rede">
              <v-card color="grey" height="250" width="250" v-if="!imagem && !croppingLogo">
                <v-layout justify-center align-center fill-height>
                  <div class="title white--text pa-4 text-xs-center">Sem imagem</div>
                </v-layout>
              </v-card>
              <v-layout justify-center align-center fill-height v-if="!imagem">
                <v-flex xs12 v-show="croppingLogo">
                  <vue-croppie ref="croppieRef" :enableExif="true" :enforceBoundary="true" :enableResize="false"
                    :enableOrientation="false" :mouseWheelZoom="true" :showZoomer="false"
                    :boundary="{ width: 250, height: 250 }"
                    :viewport="{ width: 200, height: 200, type: 'circle' }"></vue-croppie>
                  <v-btn flat @click="recortarLogo" color="grey darken-2" block class="mt-3">Recortar imagem</v-btn>
                </v-flex>
              </v-layout>
              <v-btn class="mt-3" block color="primary" @click="$refs.logoInput.click()" v-if="mostrar">
                Inserir imagem
                <input type="file" style="display:none" accept="image/*" ref="logoInput" @input="carregarLogo" />
              </v-btn>
            </v-flex>
            <v-text-field class="mt-3" outline label="Nome da rede" v-model="nome_rede" />
          </v-layout>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="3">
          <v-layout column class="pa-4">
            <h2 style="width: 100%; text-align: center;" class="mb-2">Insira a capa da rede</h2>
            <v-flex align-self-center>
              <img v-if="capa && mostrar2" :src="capa" alt="Capa da rede" width="500">
              <v-card color="grey" height="250" width="500" v-if="!capa && !croppingCapa">
                <v-layout justify-center align-center fill-height>
                  <div class="title white--text pa-4 text-xs-center">Sem imagem</div>
                </v-layout>
              </v-card>
              <v-layout justify-center align-center fill-height v-if="!capa">
                <v-flex xs12 v-show="croppingCapa">
                  <vue-croppie ref="croppieCapaRef" :enableExif="true" :enforceBoundary="true" :enableResize="false"
                    :enableOrientation="false" :mouseWheelZoom="true" :showZoomer="false"
                    :boundary="{ width: 500, height: 250 }" :viewport="{ width: 350, height: 200 }"></vue-croppie>
                  <v-btn flat @click="recortarCapa" color="grey darken-2" block class="mt-3">Recortar imagem</v-btn>
                </v-flex>
              </v-layout>
              <v-btn class="mt-3" block color="primary" @click="$refs.capaInput.click()" v-if="mostrar2">
                Inserir imagem
                <input type="file" style="display:none" accept="image/*" ref="capaInput" @input="carregarImagem" />
              </v-btn>
            </v-flex>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="4">
          <v-layout row wrap justify-center class="pa-2">
            <v-flex xs12>
              <h2 class="text-xs-center">Selecione o principal posto da rede</h2>
            </v-flex>
            <v-flex xs12>
              <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;" class="mr-1">
                <v-list-tile v-for="(posto, index) in postosSemRede" :key="index" ripple
                  @click="inserirPostoMatriz(posto)">
                  <v-list-tile-avatar>
                    <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                    <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="postosSemRede.length === 0">
                  <v-list-tile-content>
                    <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="5">
          <v-layout row wrap justify-space-between class="pa-2">
            <v-flex xs12>
              <h2 class="text-xs-center">Insira os postos na rede</h2>
            </v-flex>
            <v-flex xs6>
              <h4 class="text-xs-center">Postos sem rede</h4>
              <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;" class="mr-1">
                <v-list-tile v-for="(posto, index) in postosSemRede" :key="index" ripple
                  @click="inserirEmRede(posto, index)">
                  <v-list-tile-avatar>
                    <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                    <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="postosSemRede.length === 0">
                  <v-list-tile-content>
                    <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex xs6>
              <h4 class="text-xs-center">Postos da rede</h4>
              <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em" class="ml-1">
                <v-list-tile v-for="(posto, index) in postosDaRede" :key="index" ripple
                  @click="removerDaRede(posto, index)">
                  <v-list-tile-avatar>
                    <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                    <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="postosDaRede.length === 0">
                  <v-list-tile-content>
                    <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-footer class="pa-2" padless color="white" v-bind="{ 'absolute': true }">
      <v-btn class="mb-4" :disabled="step > 2" @click="btnCancelar">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn class="mb-4" color="primary" :disabled="!mostrar || !mostrar2" @click="btnCadastrar">Cadastrar</v-btn>
    </v-footer>
  </v-card>
</template>

<script>
export default {
  props: ['rede_posto', 'first'],
  data () {
    return {
      step: 1,
      nome_rede: '',
      postosSemRede: [],
      postosDaRede: [],
      croppingLogo: false,
      croppingCapa: false,
      mostrar: true,
      mostrar2: true,
      imagem: null,
      rede: null,
      matriz: null,
      capa: null
    }
  },
  methods: {
    carregarLogo (event) {
      this.imagem = null
      this.mostrar = false
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = e => {
          this.croppingLogo = true
          this.$refs.croppieRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    carregarImagem (event) {
      this.capa = null
      this.mostrar2 = false
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = e => {
          this.croppingCapa = true
          this.$refs.croppieCapaRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieCapaRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    recortarLogo () {
      this.mostrar = true
      let options = {
        type: 'base64',
        format: 'png',
        circle: true
      }
      this.$refs.croppieRef.result(options, output => {
        this.imagem = output
        this.croppingLogo = false
      })
    },
    recortarCapa () {
      this.mostrar2 = true
      let options = {
        type: 'base64',
        format: 'png'
      }
      this.$refs.croppieCapaRef.result(options, output => {
        this.capa = output
        this.croppingCapa = false
      })
    },
    cadastrarRede () {
      this.$store.dispatch('cadastrarRede', {
        nome: this.nome_rede
      }).then(() => {
        this.$emit('success', 'Rede Cadastrada. Agora selecione o posto pricipal.')
      })
    },
    pegarPostoSemRede () {
      this.$store.dispatch('postosSemRede').then(value => {
        this.postosSemRede = value.slice()
      })
    },
    pegarPostoDaRede (id) {
      this.$store.dispatch('postosDaRede', id).then(value => {
        this.postosDaRede = value.slice()
      })
    },
    inserirEmRede (posto, index) {
      this.postosDaRede.push(posto)
      this.postosSemRede.splice(index, 1)
    },
    removerDaRede (posto, index) {
      if (posto.cnpj === this.matriz.cnpj) {
        alert('Você não pode remover o posto matriz')
        return
      }
      this.postosSemRede.push(posto)
      this.postosDaRede.splice(index, 1)
    },
    inserirPostoMatriz (posto) {
      this.$store.dispatch('inserirPostoMatriz', {
        id: this.rede.id_rede,
        cnpj: posto.cnpj
      }).then(() => {
        this.matriz = posto
        this.postosDaRede.push(posto)
        this.$emit('success', 'Posto pricipal selecionado. Agora insirar os postos pertencentes a rede.')
        this.pegarPostoSemRede()
        this.step++
      })
    },
    btnCancelar () {
      switch (this.step) {
        case 1:
          this.$emit('fechar')
          break
        case 2:
          this.$emit('fechar')
          break
        case 3:
          alert('Você precisa inserir uma capa.')
          break
        case 4:
          alert('Você precisa selecionar um posto')
          break
        case 5:
          alert('Você precisa insirir os postos na rede')
      }
    },
    btnCadastrar () {
      switch (this.step) {
        case 1:
          this.step++
          break
        case 2:
          this.$store.dispatch('cadastrarRede', {
            nome: this.nome_rede
          }).then(rede => {
            this.rede = rede
            if (this.imagem) {
              this.$store.dispatch('inserirArquivoFirebase', {
                arquivo: this.imagem,
                prefixo: 'redes/logo/',
                id: rede.id_rede,
                local: 'redes',
                tipo: 'png'
              }).then(downloadUrl => {
                this.$store.dispatch('atualizarRede', {
                  url_logo: downloadUrl,
                  id_rede: rede.id_rede
                })
              }).then(() => {
                this.step++
              })
            } else this.step++
          })
          break
        case 3:
          if (this.capa) {
            this.$store.dispatch('inserirArquivoFirebase', {
              arquivo: this.capa,
              prefixo: 'redes/capa/',
              id: this.rede.id_rede,
              local: 'redes/',
              tipo: 'png'
            }).then(downloadUrl => {
              this.$store.dispatch('atualizarRede', {
                capa: downloadUrl,
                id_rede: this.rede.id_rede
              })
            }).then(() => {
              this.step++
            })
          }
          break
        case 4:
          alert('Clique em um posto')
          break
        case 5:
          if (this.postosDaRede.length < 2 && this.rede.is_white_label) {
            alert('Quantidade de postos é insuficientes.')
            return
          }
          let lista = []
          this.postosDaRede.map(posto => {
            lista.push(posto.cnpj)
          })
          this.$store.dispatch('inserirEmRede', {
            lista: lista,
            id_rede: this.rede.id_rede
          }).then(() => {
            this.$store.dispatch('pegarRedes')
            this.$emit('success', 'Rede cadastrada com sucesso.')
            this.$emit('fechar')
          })
      }
    }
  },
  beforeMount () {
    if (!this.first) {
      this.step = 2
    }
  },
  mounted () {
    this.pegarPostoSemRede()
    if (this.rede_posto) {
      this.pegarPostoDaRede(this.rede_posto.id_rede)
    }
  }
}
</script>
